import { call, put, takeEvery, select } from "redux-saga/effects";
import { actions, constants } from "./redux";
import Api from "../../utils/Api";
import { constants as ownerDetailsConstants } from "../owner-details/redux";
import { actions as ownerDetailsActions } from "../owner-details/redux";
import { addSuccess, addError } from "../notifications/actions";
import { getLocation } from "connected-react-router";
import { matchPath } from 'connected-react-router';
import { get } from "lodash";

function* fetchItems({ payload }) {
  try {
    const { pathname } = yield select(getLocation);
    const correctPath = matchPath(pathname, {
      path: "/owners/:id/retention-rate",
    });
    if (!correctPath) return;

    yield put(actions.loadItemRequest());

    const { data } = yield call(Api.owner.getRRRoles, payload.id);

    yield put(actions.addItems(data));
  } catch (e) {
    console.error(e);
    yield put(actions.loadItemsError(e));
  }
}

function* loadRRData({ payload }) {
  try {
    const { id, years = 5 } = payload;
    const response = yield call(Api.owner.getRetentionRate, id, years);

    yield put(actions.setRRData(response.data.data));
  } catch (e) {
    console.error(e);
  }
}

function* assignRRRole({ payload }) {
  const { id, data, message, cb } = payload;

  try {
    yield call(Api.owner.addRelation, id, "rr_roles", data);

    yield put(ownerDetailsActions.loadItemRequest());
    yield put(actions.loadRRData({ id }));

    yield put(addSuccess(message));
  } catch (e) {
    console.error(e);

    if (get(e, "apiErrors[0].status") === "400") {
      yield put(addError("Role is already assigned for RR tracking"));
    }
  } finally {
    if (cb) cb();
  }
}

function* unassignRRRole({ payload }) {
  const { id, data, cb } = payload;

  try {
    yield call(Api.owner.deleteRelation, id, "rr_roles", data);

    yield put(ownerDetailsActions.loadItemRequest());
    yield put(actions.loadRRData({ id }));

    yield put(addSuccess("Role removed from RR tracking successfully"));
  } catch (e) {
    console.error(e);
  } finally {
    if (cb) cb();
  }
}

function* calculateCustomRangeRR({ payload }) {
  try {
    const { id, startDate, endDate } = payload;
    const response = yield call(Api.owner.getRetentionRateByRange, id, startDate, endDate);

    yield put(actions.setCustomRangeRR(response.data.data));

    yield put(addSuccess(`RR for range ${startDate} to ${endDate} calculated successfully`));
  } catch (e) {
    console.error(e);
    throw e;
  }
}

// Admin-only .xlsx with the RR source table (pool history + per-year
// AE/UW/RR% summary). The Api helper saves the blob itself; the saga only
// tracks the in-flight flag and surfaces the outcome.
export function* downloadReport({ payload }) {
  try {
    yield put(actions.setReportDownloading(true));
    yield call(Api.owner.downloadRetentionRateReport, payload.id);
    yield put(addSuccess('Retention Rate report downloaded'));
  } catch (e) {
    console.error(e);
    yield put(addError('Could not download the Retention Rate report'));
  } finally {
    yield put(actions.setReportDownloading(false));
  }
}

/**
 * getFeatureSagas
 * each saga file should return all feature sagas
 * @returns {ForkEffect[]}
 */
export default function getFeatureSagas() {
  return [
    takeEvery(ownerDetailsConstants.ADD_LOADED_ITEM, fetchItems),
    takeEvery(constants.LOAD_RR_DATA, loadRRData),
    takeEvery(constants.ASSIGN_RR_ROLE, assignRRRole),
    takeEvery(constants.UNASSIGN_RR_ROLE, unassignRRRole),
    takeEvery(constants.CALCULATE_CUSTOM_RANGE, calculateCustomRangeRR),
    takeEvery(constants.DOWNLOAD_REPORT, downloadReport),
  ];
}
